// extracted by mini-css-extract-plugin
export default {"desc":"Rules_desc__rkuwN","clearButton":"Rules_clearButton__mhgRQ"};